module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1075.deb341b2.png";